'use client';

import { forwardRef, ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/utils/cn';

export const Form = forwardRef<HTMLFormElement, ComponentPropsWithoutRef<'form'>>(
  ({ className, ...props }, ref) => (
    <form ref={ref} className={cn('text-base', className)} {...props} />
  ),
);
Form.displayName = 'Form';
